type ChatRow = {
  id: string;
  lastActivityAt: number | null;
  lastActiveAt?: number | null;
  pinned?: boolean;
  responding?: boolean;
  awaitingAction?: boolean;
  workflow?: { id: string } | null;
};

// A workflow’s version chats share one row, which opens the version in view or else the one last viewed.
export function groupWorkflowChats<T extends ChatRow>(
  chats: readonly T[],
  activeChatId: string | null
): T[] {
  const groups = Map.groupBy(
    chats.filter((chat) => chat.workflow),
    (chat) => chat.workflow!.id
  );
  return chats.flatMap((chat) => {
    if (!chat.workflow) return [chat];
    const group = groups.get(chat.workflow.id)!;
    if (group[0] !== chat) return [];
    const shown =
      group.find((member) => member.id === activeChatId) ??
      group.toSorted(
        (a, b) => (b.lastActiveAt ?? 0) - (a.lastActiveAt ?? 0)
      )[0]!;
    return [
      {
        ...shown,
        lastActivityAt: Math.max(
          ...group.map((member) => member.lastActivityAt ?? 0)
        ),
        pinned: group.some((member) => member.pinned),
        responding: group.some((member) => member.responding),
        awaitingAction: group.some((member) => member.awaitingAction),
      },
    ];
  });
}
